import Cover from "@components-pages/home/cover";
import RemaxV2ActionSections from "@components-pages/home/remax-v2-action-sections";
import HeadMeta, { IHeadMetaComponent } from "@components/head-meta";
import { en, es } from "lang";
import { CKeyWordsPages } from "shared/models/const/keywords.const";

import type { GetStaticPropsContext, NextPage } from "next";

const Home: NextPage = (props) => {
  const metaData: IHeadMetaComponent = {
    keyWords: CKeyWordsPages.home,
    description: "home",
    url: "/",
    title: "home",
    picture: "/images/image-optimize/living_meta.jpg",
  };

  return (
    <div>
      <HeadMeta {...metaData} />

      <Cover />
      <RemaxV2ActionSections />
    </div>
  );
};

export default Home;

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      messages: locale === "es" ? es : en,
    },
  };
}
